import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const getGrammarAudioCoverageV1DataSchemaDefinition = z.object({
  full: z.number().int().min(0),
  partial: z.number().int().min(0),
  none: z.number().int().min(0),
  total: z.number().int().min(0),
});

export const getGrammarAudioCoverageV1DataSchema: typeof getGrammarAudioCoverageV1DataSchemaDefinition =
  getGrammarAudioCoverageV1DataSchemaDefinition;

export type IGetGrammarAudioCoverageV1Data = z.infer<typeof getGrammarAudioCoverageV1DataSchema>;

export const getGrammarAudioCoverageV1ResponseSchema: z.ZodSchema<
  IAPI<IGetGrammarAudioCoverageV1Data>
> = createApiResponseSchema(getGrammarAudioCoverageV1DataSchema) as z.ZodSchema<
  IAPI<IGetGrammarAudioCoverageV1Data>
>;

export type IGetGrammarAudioCoverageV1Response = IAPI<IGetGrammarAudioCoverageV1Data>;
